import React, { useEffect, useRef } from 'react';
import { ChevronLeft, ChevronRight, ExternalLink, Star } from 'lucide-react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';

const API = process.env.REACT_APP_BACKEND_URL;

export const PhotoLightbox = ({ photos, index, onIndex, onClose, onSetCover }) => {
    const touchX = useRef(null);
    const open = index !== null && index >= 0;
    const photo = open ? photos[index] : null;
    const go = (d) => onIndex((index + d + photos.length) % photos.length);

    useEffect(() => {
        if (!open) return undefined;
        const onKey = (e) => { if (e.key === 'ArrowRight') go(1); if (e.key === 'ArrowLeft') go(-1); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    });

    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
            <DialogContent className="max-w-5xl w-[96vw] p-3 bg-neutral-950 border-neutral-800 text-white" data-testid="photo-lightbox">
                <DialogHeader>
                    <DialogTitle className="text-sm font-normal truncate pr-8 text-white/90" data-testid="photo-lightbox-title">
                        {photo?.filename} <span className="text-white/50 ml-2">{index + 1} / {photos.length}</span>
                    </DialogTitle>
                    <DialogDescription className="sr-only">Galleria foto</DialogDescription>
                </DialogHeader>
                <div
                    className="relative h-[72vh] flex items-center justify-center select-none"
                    onTouchStart={(e) => { touchX.current = e.touches[0].clientX; }}
                    onTouchEnd={(e) => {
                        if (touchX.current === null) return;
                        const dx = e.changedTouches[0].clientX - touchX.current;
                        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
                        touchX.current = null;
                    }}
                >
                    {photo && <img key={photo.id} src={`${API}${photo.url}`} alt={photo.filename} className="max-w-full max-h-full object-contain animate-in fade-in duration-200" data-testid="photo-lightbox-image" />}
                    {photos.length > 1 && (
                        <>
                            <button type="button" onClick={() => go(-1)} className="absolute left-1 top-1/2 -translate-y-1/2 p-2 rounded-full bg-black/50 hover:bg-black/80 transition-colors" data-testid="photo-lightbox-prev"><ChevronLeft size={26} /></button>
                            <button type="button" onClick={() => go(1)} className="absolute right-1 top-1/2 -translate-y-1/2 p-2 rounded-full bg-black/50 hover:bg-black/80 transition-colors" data-testid="photo-lightbox-next"><ChevronRight size={26} /></button>
                        </>
                    )}
                </div>
                <div className="flex justify-end gap-2">
                    {onSetCover && photo && (photo.is_cover ? (
                        <span className="inline-flex items-center gap-1 text-xs px-3 rounded-sm bg-amber-500/20 text-amber-300" data-testid="photo-lightbox-is-cover">
                            <Star size={14} className="fill-current" /> Copertina
                        </span>
                    ) : (
                        <Button variant="secondary" size="sm" onClick={() => onSetCover(photo)} data-testid="photo-lightbox-set-cover-btn">
                            <Star size={14} className="mr-2" /> Usa come copertina
                        </Button>
                    ))}
                    <Button variant="secondary" size="sm" onClick={() => window.open(`${API}${photo.url}`, '_blank')} data-testid="photo-lightbox-open-btn">
                        <ExternalLink size={14} className="mr-2" /> Apri / Scarica
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};
